<template>
  <div class="share-block"
       tabindex="-1"
    @mouseleave="hideShown"
    @mouseover="showShown"
    :class="{shown: show_share}">
    <default-button
      class="share-block_btn"
      @click="show_share = true"
      is_light bordered>
      <share-icon class="mr-10"/>
      {{ $t('btn.share') }}
    </default-button>
    <div class="share-block_items">
      <div
        class="share-block_item"
        @click="shareFb"
        role="button" aria-label="Share facebook">
        <facebook-icon/>
      </div>
      <div
        class="share-block_item"
        @click="shareLd"
        role="button" aria-label="Share linkedin">
        <linkedin-icon/>
      </div>
      <div
        class="share-block_item"
        @click="copyYrl"
        role="button" aria-label="Copy url">
        <check-animated-icon
          v-if="copy_check"
          class="share-block_item-stroke"/>
        <url-icon v-else/>
      </div>
    </div>
  </div>
</template>

<script>

import {ssr_window} from "../../helpers/ssr";
import DefaultButton from "../slots/DefaultButton.vue";
import ShareIcon from "../icons/ShareIcon.vue";
import FacebookIcon from "../icons/FacebookIcon.vue";
import LinkedinIcon from "../icons/LinkedinIcon.vue";
import {currentUrl} from "../../helpers/query_helper";
import UrlIcon from "../icons/UrlIcon.vue";
import CheckAnimatedIcon from "../icons/CheckAnimatedIcon.vue";

export default {
  name: "ShareButton",
  components: {
    CheckAnimatedIcon,
    UrlIcon,
    LinkedinIcon,
    FacebookIcon,
    ShareIcon,
    DefaultButton
  },
  computed: {
    current_url() {
      return currentUrl()
    }
  },
  data() {
    return {
      show_share: false,
      timeout_f: null,
      copy_check: false
    }
  },
  methods: {
    showShown() {
      if (this.timeout_f) {
        clearTimeout(this.timeout_f)
      }
    },
    hideShown() {
      if (this.timeout_f) {
        clearTimeout(this.timeout_f)
      }
      this.timeout_f = setTimeout(() => {
        this.show_share = false
        this.copy_check = false
      }, 1200)
    },
    shareFb() {
      ssr_window.open(`https://www.facebook.com/share.php?u=${encodeURI(this.current_url)}`)
    },
    shareLd() {
      ssr_window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(this.current_url)}`)
    },
    copyYrl() {
      ssr_window.navigator.clipboard.writeText(encodeURI(this.current_url));
      this.copy_check = true
      setTimeout(() => {
        this.copy_check = false
      }, 1200)
    }
  }
}
</script>
